var exports = {
  "kL": "DiscoverySearchFilters.module__container___VjR5en",
  "uW": "DiscoverySearchFilters.module__section___VjR5en",
  "SF": "DiscoverySearchFilters.module__sectionHeading___VjR5en",
  "jv": "DiscoverySearchFilters.module__categoryList___VjR5en",
  "af": "DiscoverySearchFilters.module__categoryItem___VjR5en",
  "Cm": "DiscoverySearchFilters.module__categoryItemActive___VjR5en",
  "Jm": "DiscoverySearchFilters.module__categoryLabel___VjR5en",
  "_E": "DiscoverySearchFilters.module__categoryCount___VjR5en",
};

module.exports = exports;
